// @ts-nocheck
import getCssUnitField, { CssUnitFieldOptions } from "@store/Framework/Common/Fields/Toolkit/cssUnit";

export const getContextualCssUnitField: typeof getCssUnitField = (name: string, options?: CssUnitFieldOptions) => {
    const field = getCssUnitField(name, options);
    return {
        ...field,
        definition: {
            ...field.definition,
            fieldType: "Contextual",
        },
    };
};
